// extracted by mini-css-extract-plugin
export default {"container":"ProductThumbnail_container__YPSTT","thumbnailWrapper":"ProductThumbnail_thumbnailWrapper__02KZl","content":"ProductThumbnail_content__HhfH6"};